export const WaitingPage = {
    init: () => {
        const orderId = document.querySelector<HTMLInputElement>('#orderId');
        const redirectUrl = document.querySelector<HTMLInputElement>('#redirectUrl');

        if (orderId && redirectUrl) {
            fetch(`umbraco/api/bc/checkNavOrderId?orderid=${encodeURIComponent(orderId.value)}`)
                .then(response => {
                    if (response.ok) {
                        return response.json(); // Parse the response as JSON
                    } else {
                        throw new Error(`Failed to validate order ID: ${response.status}`);
                    }
                })
                .then(data => {
                    const navOrderId = data.NavOrderId; // Extract navOrderId from the JSON response
                    if (navOrderId) {
                        // Redirect with the navOrderId as a query parameter
                        window.location.href = `${redirectUrl.value}?orderId=${encodeURIComponent(navOrderId)}`;
                    } else {
                        console.error('NavOrderId is empty or null.');
                    }
                })
                .catch(error => {
                    console.error('Error during fetch:', error);
                });
        }
        
    },
}
